export const ratingStrings = {
	1: 'Ужасно',
	2: 'Плохо',
	3: 'Нормально',
	4: 'Хорошо',
	5: 'Прекрасно',
	BADLY: 'Плохо',
	badly: 'Плохо',
	NORMAL: 'Нормально',
	normal: 'Нормально',
	GOOD: 'Хорошо',
	good: 'Хорошо',
	EXCELLENT: 'Отлично',
	excellent: 'Отлично',
	MATCH: 'Подходит',
	match: 'Подходит',
	NO_MATCH: 'Не подходит',
	noMatch: 'Не подходит',
	UNKNOWN: 'Неизвестно',
	unknown: 'Неизвестно',
};

export const ratingColors = {
	1: 'error',
	2: 'warning.main',
	3: 'secondary',
	4: 'success.main',
	5: 'primary.main',
	BADLY: 'warning.main',
	badly: 'warning.main',
	NORMAL: 'secondary',
	normal: 'secondary',
	GOOD: 'success.main',
	good: 'success.main',
	EXCELLENT: 'primary.main',
	excellent: 'primary.main',
	MATCH: 'success.main',
	match: 'success.main',
	NO_MATCH: 'error',
	noMatch: 'error',
	UNKNOWN: 'secondary',
	unknown: 'secondary',
};

export const getRatingString = (value) => ratingStrings[value] ?? 'Неизвестно';
export const getRatingColor = (value) =>
	ratingColors[value] ?? 'secondary.main';
